<div class="yf-row centered">
  <div class="group">
    <ion-card class="yf-container gap-12 p-24 filter-card">
      <div class="card-body">
        <div class="yf-container gap-6">
          <ion-text color="medium"> {{ "APP.FILTER.CONNECTORS" | translate }} </ion-text>
          <yf-filter-connector-selector [selectedConnector]="$resolvedFilter().plugs"
            (filterEvent)="updateModel($event, 'plugs')"></yf-filter-connector-selector>
        </div>
        <hr />
        <div class="yf-container gap-6">
          <ion-text color="medium"> {{ "APP.FILTER.PLUG_POWER" | translate }} </ion-text>
          <app-power-range [selectedRange]="$resolvedFilter().range"
            (filterEvent)="updateModel($event, 'range')"></app-power-range>
        </div>
        <hr />
        <div class="yf-container gap-6">
          <ion-text color="medium"> {{ "APP.FILTER.CPO" | translate }} </ion-text>
          <yf-filter-cpo-selector [selectedCpos]="$resolvedFilter().cpos || []"
            [selectedOperatorIds]="$resolvedFilter().operatorIds || []"
            (filterOutput)="updateOperatorFilters($event)"
            [cpos]="cpos()"></yf-filter-cpo-selector>
        </div>
        @if($text()){
        <div class="error">
        <ion-icon name="alert-circle-outline" class="mr-10 fs-40" ></ion-icon>
        <ion-text class="fs-12 fw-600">
          <b> {{"TOAST_MESSAGES.WARNING" | translate}}:</b> {{ "APP.FILTER.NO_RESULT" | translate}} {{$text() | translate}}
        </ion-text>
      </div>
      }
      </div>
      @if(!isDefaultFilter()){
      <div class="card-footer">
        <ion-button class="reset-btn" fill="solid" color="dark" size="small" (click)="resetFilters()">
          <ion-icon name="sparkles-outline" slot="start"></ion-icon>
          {{ "APP.FILTER.RESET" | translate }}
        </ion-button>
      </div>
      }
    </ion-card>
  </div>
</div>
